import classNames from 'classnames';
import React from 'react';
import './icon.scss';

const Icon = ({ className, icon, thickness, ...other }) => {
  const currentIcon = typeof icon === 'string' ? '' : icon;
  const currentIconStyle = currentIcon['custom-stroke-deltas'] || [];
  const currentIconType = currentIcon['icon-type'] || '';

  const strokeWidths = {
    normal: 2,
    thin: 1.2,
    xthin: 0.5,
  };
  const viewBox = currentIcon?.viewbox || '';

  const getStrokeWidth = (strokeCurrentDelta = 0) => {
    const viewBoxX = Number(viewBox.split(' ')[2]);
    const viewBoxY = Number(viewBox.split(' ')[3]);
    const average = (viewBoxX + viewBoxY) / 2;
    const strokeCurrent = strokeWidths[thickness];
    const strokeDelta =
      (strokeCurrent * strokeCurrentDelta) / strokeWidths['normal'];
    return (strokeCurrent + strokeDelta) / average;
  };

  const getCssClassStrokeWidth = (cssDifferentStrokes, item) => {
    return (cssDifferentStrokes += `
    ${item['css-classname']} {
      stroke-width: calc(100% * ${getStrokeWidth(item['delta'])});
    }
    `);
  };

  const cssCustom = () => `
  .svg-icon[data-svgid='${currentIcon?.icon}'] {
    stroke-width: calc(100% * ${getStrokeWidth()});
  }
  ${currentIconStyle.reduce(getCssClassStrokeWidth, '')}
  `;

  return (
    currentIcon && (
      <svg
        className={classNames('svg-icon', className, {
          'svg-icon--custom-stroke': currentIconType === 'stroked',
          'svg-icon--stroke-normal':
            thickness === 'normal' && currentIconType === 'stroked',
          'svg-icon--stroke-thin':
            thickness === 'thin' && currentIconType === 'stroked',
          'svg-icon--stroke-xthin':
            thickness === 'xthin' && currentIconType === 'stroked',
        })}
        data-svgid={currentIcon?.icon}
        viewBox={viewBox}
        {...other}
      >
        {currentIconStyle.length > 0 && <style>{cssCustom()}</style>}

        <g dangerouslySetInnerHTML={{ __html: currentIcon?.markup }}></g>
      </svg>
    )
  );
};

export default Icon;
